import { render, staticRenderFns } from "./SearchGroups.vue?vue&type=template&id=08d62d8a&scoped=true"
import script from "./SearchGroups.vue?vue&type=script&lang=js"
export * from "./SearchGroups.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SearchGroups.vue?vue&type=style&index=1&id=08d62d8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d62d8a",
  null
  
)

export default component.exports